<template>
  <div class="flex gap-2 mt-5">
    <a-button type="primary"
              html-type="submit"
              :loading="loading"
              style="border-radius: 3px !important"
    >
      Generate Report
    </a-button>
    <a-button type="primary"
              ghost
              :disabled="loading"
              @click="$emit('backPage')"
              style="border-radius: 3px !important"
    >
      Cancel
    </a-button>
  </div>
</template>

<script>
export default {
  name: "BtnSubmitReport",
  data() {
    return {
      loading: false
    }
  }
}
</script>

<style scoped>

</style>
